import { AssessmentResult } from "@store/generalTypes";
import { isEmpty } from "lodash";
import { Translate } from "react-i18nify";
import { NotesContainer } from "./notesContainer";

export const NotesBanner = (assessment: AssessmentResult): JSX.Element => {
    return (
        <div className="box is-shadowless has-background-lightest-blue p-3">
            <h2 className="is-6 has-text-darkest-blue">
                <Translate value="admin.latestNote" />
            </h2>
            {isEmpty(assessment.notes) ? (
                <div className="is-size-7 has-text-primary-blue py-3">
                    <Translate value="admin.noNotes" />
                </div>
            ) : (
                <NotesContainer notes={[assessment.notes![assessment.notes!.length - 1]]} />
            )}
        </div>
    );
};
